import { Injectable } from '@angular/core';
@Injectable()
export class DataLayerService {
	constructor() {}

	pushToDataLayer(data: any) {
		window?.dataLayer?.push(data);
	}
}
